import { IEditableFormatObject } from "../../../../../../domain/editableFormat";
import { ElementTypes } from "../../../../../../domain/editableFormat/objects";
import { IXElementContentsObjectBean } from "../../../beans";

export class ElementNameTranslator {
  from(bean: IXElementContentsObjectBean): ElementTypes {
    return bean["@element-name"] as ElementTypes;
  }

  to(object: IEditableFormatObject): string {
    return object.elementName;
  }
}
